import { render, staticRenderFns } from "./inst.vue?vue&type=template&id=4a12e705&scoped=true"
import script from "./inst.vue?vue&type=script&lang=js"
export * from "./inst.vue?vue&type=script&lang=js"
import style0 from "./inst.vue?vue&type=style&index=0&id=4a12e705&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a12e705",
  null
  
)

export default component.exports